<template>
  <router-view />
</template>

<script>
export default {
  name: "finance",
  components: {},
};
</script>
